const state = {
    currentComponent: 'consent',
}

const mutations = {
    SET_COMPONENT(state, target) {
        state.currentComponent = target
    },
}

const actions = {
    changeTo: ({ commit }, target) => {
        commit('SET_COMPONENT', target)
    },
}

const getters = {
    currentComponent: (state) => {
        return state.currentComponent
    },
}

export default {
    state,
    mutations,
    actions,
    getters,
}



// WEBPACK FOOTER //
// ./src/store/modules/dashboard.js